import axios from 'axios';
import Moment from 'moment';
import { DatatableData, DatatableConvertedData } from './types/ProjectListStaff';
import { FileInputStatus } from './types/FileUpload';
import { http_status_code_list } from './Const';
import { Content } from './types/Template';
import { ItemKey } from './const/Corporate';

/**
 * 指定URLへ遷移
 * @param string url URL
 * @return void
 */
export const jumpUrl = (url: string) => {
  if (url) {
    // urlがセットされていれば、そのurl画面に遷移する
    location.href = url;
  }
};

/**
 * 単項目のバリデーション、ドメインチェック
 */
export const domainCheckRequest = async (type: string, value: string) => {
  try {
    const response = await axios.post(
      `${location.origin}${process.env.MIX_MOCK_URL}/validation/domain/check`,
      {
        type,
        value,
      }
    );
    return Promise.resolve(response);
  } catch (error) {
    return Promise.reject(error);
  }
};

/**
 * MDBDatatableに投入するためのデータに変換する
 */
export const convertMDBDatatableRowData = (datas: DatatableData[]) => {
  return datas.map((data: DatatableData, index: number) => ({
    no: index + 1,
    branch_office_in_charge: data.branch_office_in_charge, // 担当店舗(=取引店)
    project_number: data.project_number,
    name: data.name,
    account_number: data.account_number,
    fund_use: data.fund_use,
    reception_date: data.reception_date, // 受付日(=WEB受付の申込日)
    status: data.status, // 案件ステータス
    pr_decision: data.pr_decision, // 事前審査諾否
    clickEvent: () =>
      (location.href = `${location.origin}${process.env.MIX_MOCK_URL}${data.transition}`),
  }));
};

/**
 * Base64からBlobをに変換する
 * @param base64 base64文字列
 * @param mime MIME TYPE
 * @returns Blob
 */
export const toBlob = (base64: string, mime: string) => {
  const bin = atob(base64.replace(/^.*,/, ''));
  const buffer = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) {
    buffer[i] = bin.charCodeAt(i);
  }
  // Blobを作成
  try {
    const blob = new Blob([buffer.buffer], {
      type: mime,
    });
    return blob;
  } catch (e) {
    console.error(e);
    return '';
  }
};

/**
 * 通信レスポンスが401(認証エラー)の場合は認証を促すアラートを表示する
 * @param number status ステータスコード
 * @returns void
 */
export const authErrorTimeout = (status: number) => {
  if (status === http_status_code_list.unauthorized) {
    location.replace(`${location.origin}${process.env.MIX_MOCK_URL}/timeout`);
  }
};

/**
 * エラーメッセージがあるかの判定
 * @param {Content[]} contents 表示コンテンツ
 * @returns {boolean}
 */
 export const hasErrorMessage = (contents: Content[]): boolean => {
  return contents.some(content => content.message);
};

/**
   * 法人情報関連画面 文字列のフォーマット
   * @param value フォーマットする文字列
   * @param key キー名
   * @returns string
   */
export const CorporationInfoFormatValue = (value: string, key: string) => {
  if (value === null || typeof value === 'undefined' || value.length === 0) {
    return '';
  }

  switch (key) {
    case ItemKey.approval_date:
    case ItemKey.created_at:
    case ItemKey.updated_at:
    case ItemKey.start_date:
    case ItemKey.end_date:
      // 日付をフォーマットする
      return Moment(value).format('YYYY-MM-DD');
    default:
      // フォーマット対象でないので文字列をそのまま返却する
      return value;
  }
};

/**
 * 16文字以上の場合は先頭15文字に「…」三点リーダーを付与する
 *
 * @param {string} original 加工前の文字列
 * @returns {string} 加工後の文字列
 */
export const addEllipsis = (original: string): string => {
  let result = original;

  if (result.length >= 16) {
    result = result.substring(0, 15) + "…";
  }

  return result ;
};

/*
 * 契約書名がnullまたはundefinedだった場合は固定の契約書名にする
 * @param {string | undefined} contract_name 契約書名
 * @returns {string}
 */
export const getContractName = (contract_name: string | undefined): string => {
  return contract_name ?? 'ContractDocument';
};
